// extracted by mini-css-extract-plugin
var _1 = "tjs-mobile-search__btnList tjs-_base__clearfix tjs-_base__list-reset";
var _2 = "tjs-mobile-search__data";
var _3 = "tjs-mobile-search__items";
var _4 = "tjs-mobile-search__label";
var _5 = "tjs-mobile-search__location";
var _6 = "tjs-mobile-search__provider-result";
var _7 = "tjs-mobile-search__provider-result";
var _8 = "tjs-mobile-search__results tjs-_base__list-reset";
export { _1 as "btnList", _2 as "data", _3 as "items", _4 as "label", _5 as "location", _6 as "provider-result", _7 as "providerResult", _8 as "results" }
export default { "btnList": _1, "data": _2, "items": _3, "label": _4, "location": _5, "provider-result": _6, "providerResult": _7, "results": _8 }
